module.exports = __webpack_public_path__ + "imgs/person.b5dc93c8d1a91ab4d0d6f34053e943ad.svg";